import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(private api: ApiService) { }

  createSubscriberList(data:any): Observable<any> {
    return this.api.post(environment.createSubscriberList,data);
  }
  getAllSubscriberList(data:any): Observable<any> {
    return this.api.post(environment.getAllSubsciberList,data);
  }
  deleteSubscriberList(data:any): Observable<any> {
    return this.api.post(environment.deleteSubsciberList,data);
  }
  getSubsciberList(data:any): Observable<any> {
    return this.api.post(environment.getSubsciberList,data);
  }
  getAllTemplates(data:any): Observable<any> {
    return this.api.post(environment.getAllTemplates,data);
  }

  addCampaignList(data:any): Observable<any> {
    return this.api.post(environment.createCampaignList,data);
  }

  updateCampaignList(data:any): Observable<any> {
    return this.api.post(environment.updateCampaignList,data);
  }

  getAllCampaignList(data:any): Observable<any> {
    return this.api.post(environment.getAllCampaignList,data);
  }

  getAllCampaignWithCount(data:any): Observable<any> {
    return this.api.post(environment.getAllManangeCampaign,data);
  }

  deleteCampaignList(data:any): Observable<any> {
    return this.api.post(environment.deleteCampaignList,data);
  }

  sendWhatsappMsg(data:any): Observable<any> {
    return this.api.post(environment.sendWhatsappMsg,data);
  }

  sendMediaTemplateMsg(data:any): Observable<any> {
    return this.api.post(environment.sendMediaTemplateMsg,data);
  }
  getCampaignTracking(data:any): Observable<any> {
    return this.api.post(environment.getCampaignTracking,data);
  }
  getWhatsappCampaignTracking(data:any): Observable<any> {
    return this.api.post(environment.getWhatsappCampaignTracking,data);
  }
  getReputation(data:any): Observable<any> {
    return this.api.post(environment.getReputation,data);
  }

  runCampaignWhatsapp(data:any): Observable<any> {
    return this.api.post(environment.runCampaign,data);
  }

  runCampaignEmail(data:any): Observable<any> {
    return this.api.post(environment.runCampaign,data);
  }

  runCampaignTextMessage(data:any): Observable<any> {
    return this.api.post(environment.runCampaign,data);
  }
 
}
